module.exports = __webpack_public_path__ + "static/media/order_ding.4993182c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/order_ding.wav
// module id = 432
// module chunks = 0